import { mutations as mutationTypes } from '../../../ducks/resource-edges';
import { selectors as nodeSelectors } from '../../../ducks/resource-nodes';
import { handleAssetDelete, handleFolderDelete } from './handleDelete';

export const handleMutateManyResourceEdges = ({
  getState,
  dispatch,
  action
}) => {
  const { mutations = [] } = action.meta?.apiClient || {};

  mutations.forEach((m) => {
    const { relationshipLabel, resourceType } = m;

    if (resourceType === 'workspace' && relationshipLabel === 'deleted-nodes') {
      mutations.forEach((m) => {
        const { mutationType, resource } = m;
        if (
          mutationType === mutationTypes.MUTATION_ADD ||
          mutationType === 'add'
        ) {
          const nodeResource =
            nodeSelectors.getResourceById(getState(), 'asset', resource.id) ||
            nodeSelectors.getResourceById(getState(), 'folder', resource.id);
          const nodeType = nodeResource?.type || resource?.type;

          if (nodeType === 'asset') {
            handleAssetDelete({
              resourceType: 'asset',
              resourceId: resource.id,
              getState
            });
          } else if (nodeType === 'folder') {
            handleFolderDelete({
              resourceId: resource.id,
              getState,
              dispatch
            });
          }
        }
      });
    }
  });
};
